module.exports = __webpack_public_path__ + "static/media/chatham_crossing_small.973f1e50.jpg";